
import { SellersApiRemoteService } from '../../Services/api/sellers/sellers-service'
import { ISellerEntity } from '../../Services/api/sellers/sellers.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ShowSellersUseCase
implements IFormUsecase<string, ISellerEntity> {
  constructor (private readonly SellersApi: SellersApiRemoteService) {}
    

  public async handle (sellerId: string): Promise<Result<ISellerEntity>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.SellersApi.show(sellerId)

      if (response.isFailure) {
        return response
      }
    
      const list = response.getValue()

      if(!list) return response
    
      return Result.ok(list)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
